<template>
  <div
    class="vstack gap-2 align-items-start"
    v-if="appointment.meeting_type || supported_types.length <= 1"
  >
    <!-- Case: in_person -->
    <span
      class="btn text-primary p-0"
      v-if="
        appointment.meeting_type == 'in_person' ||
        (supported_types.length == 1 && appointment.meeting_types.in_person)
      "
      ><i class="bi bi-people-fill me-1"></i>
      {{
        (appointment.room != null && appointment.room !== '') ?
          $t("message.AgendaCard.room_with_value", { room: appointment.room }) :
          $t("message.AgendaCard.room")
      }}
      
    </span>
    <!-- Case: Virtual -->
    <button
      class="btn btn-sm btn-outline-primary"
      v-if="
        appointment.meeting_type == 'virtual' ||
        (supported_types.length == 1 && appointment.meeting_types.virtual)
      "
      @click="
        joinVirtualMeeting(
          appointment[getMeetingUrlProperty(appointment.meeting_types, appointment)]
        )
      "
    >
      <v-tooltip activator="parent" location="bottom" class="custom-tooltip">{{
        getMeetingType(appointment.meeting_types, appointment)
      }}</v-tooltip>
      <i class="bi bi-play-fill me-1"></i>{{ $t("message.AgendaCard.join") }}
    </button>
    <!-- Case: Phone, calling the teacher -->
    <component
      :is="appointment.phone_number ? 'a' : 'div'"
      :href="`tel:${appointment.phone_number}`"
      target="_blank"
    >
      <button
        class="btn btn-sm btn-outline-primary"
        v-if="
          appointment.meeting_type == 'phone' ||
          (supported_types.length == 1 && appointment.meeting_types.phone)
        "
        style="white-space: nowrap"
      >
        <i class="bi bi-telephone-fill me-1"></i>{{ appointment.phone_number || "Unavailable" }}
        <v-tooltip
          v-if="!appointment.phone_number"
          activator="parent"
          class="custom-tooltip"
          location="bottom"
          >Phone number not specified</v-tooltip
        >
      </button>
    </component>
    <!-- Case: Callback, requesting parent callback number -->
    <div
      class="input-group input-group-sm w-auto"
      v-if="
        appointment.meeting_type == 'callback' &&
        (!appointment.callback_number || state.editCallback)
      "
    >
      <input
        type="text"
        class="form-control rounded-start form-control-secondary"
        placeholder="Your Phone Number"
        aria-label="Your Phone Number"
        aria-describedby="button-addon2"
        v-model="state.callbackNumber"
      />
      <button
        class="btn btn-outline-secondary rounded-end"
        type="button"
        id="button-addon2"
        @click="saveCallbackNumber"
      >
        <i class="bi bi-check-lg"></i>
      </button>
    </div>
    <!-- Case: Callback, parent callback number provided -->
    <div
      class="hstack gap-1"
      v-if="
        appointment.meeting_type == 'callback' && appointment.callback_number && !state.editCallback
      "
    >
      <a :href="`tel:${appointment.callback_number}`" target="_blank">
        <button class="btn btn-sm btn-outline-primary" style="white-space: nowrap">
          <i class="bi bi-telephone-fill me-1"></i>{{ appointment.callback_number }}
        </button>
      </a>
      <button class="btn text-primary" @click="state.editCallback = true">
        <i class="bi bi-pencil-fill"></i>
      </button>
    </div>
    <!-- Case: multiple meeting types available, and user has not yet chosen -->
  </div>
  <div v-else v-t="'message.AgendaCard.choose_meeting_type'"></div>
</template>

<script setup>
import { useAgendaStore } from "@/stores/parent/agenda";
import { watch } from "vue";
import { reactive } from "vue";
import { ref, onMounted } from "vue";
import { getMeetingType, getMeetingUrlProperty } from "@/utils/meetingTypes";

const supported_types = ref([]);
const props = defineProps({
  appointment: Object
});

const agendaStore = useAgendaStore();

const state = reactive({
  callbackNumber: props.appointment.callback_number || "",
  editCallback: false
});

function joinVirtualMeeting(link) {
  if (link) window.open(link, "_blank");
}

const saveCallbackNumber = () => {
  const number = state.callbackNumber;
  if (number) {
    const meeting_detail = {
      pta_id: props.appointment.pta_id,
      callback_number: number,
      meeting_type: "callback"
    };
    // eslint-disable-next-line vue/no-mutating-props
    props.appointment.callback_number = number;
    state.editCallback = false;
    agendaStore.saveDetails(meeting_detail);
  }
};

onMounted(() => {
  if (props.appointment?.meeting_types) {
    Object.keys(props.appointment.meeting_types).forEach((type) => {
      if (props.appointment.meeting_types[type] == true) {
        supported_types.value.push(type);
      }
    });
  }
  // console.log([...supported_types.value]);
  if (!props.appointment.meeting_type && supported_types.value.length == 1) {
    // eslint-disable-next-line vue/no-mutating-props
    props.appointment.meeting_type = supported_types.value[0];
    const meeting_detail = {
      pta_id: props.appointment.pta_id,
      meeting_type: props.appointment.meeting_type,
      message: props.appointment.comment,
      callback_number: props.appointment.callback_number
    };
    agendaStore.saveDetails(meeting_detail);
  }

  watch(
    () => props.appointment.callback_number,
    () => {
      state.callbackNumber = props.appointment.callback_number || "";
    }
  );
});
</script>
